const UTIQ_HOST_PROD = 'utiq.gumtree.com';
const UTIQ_HOST_QA = 'utiq.gumtree.io';

export function getUtiqHost(domain) {
    return domain === 'gumtree.com' ? UTIQ_HOST_PROD : UTIQ_HOST_QA;
}
